import { createContext, useContext } from "react";

const PipelineBuilderContext = createContext(null);

export function usePipelineBuilder() {
  return useContext(PipelineBuilderContext);
}

export default function PipelineBuilderProvider({ value, children }) {
  return (
    <PipelineBuilderContext.Provider value={value}>
      {children}
    </PipelineBuilderContext.Provider>
  );
}
